import React from "react"
import { Link } from "gatsby"
import { SemiBdTitle4, SemiBdTitle5 } from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"

export interface HardwareDemoPropsShape {
  demo: {
    title: string
    buttonText: string
    buttonLink: {
      reference: {
        path: {
          current: string
        }
      }
    }
  }
}

const HardwareDemo = ({ demo }: HardwareDemoPropsShape) => {
  return (
    <HardwareDemoStyled>
      <SemiBdTitle4>{demo?.title}</SemiBdTitle4>
      <Link to={demo?.buttonLink?.reference?.path?.current}>
        <SemiBdTitle5>{demo?.buttonText}</SemiBdTitle5>
      </Link>
    </HardwareDemoStyled>
  )
}

export default HardwareDemo

const HardwareDemoStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${rem(40)} 0 ${rem(48)};
  background: var(--color-black);

  @media ${media.midUp} {
    padding: ${rem(64)} 0;
  }

  @media ${media.stMidUp} {
    padding: ${rem(96)} 0 ${rem(104)};
  }

  h4 {
    color: var(--color-white);
    font-size: ${rem(24)};
    line-height: ${rem(32)};
    max-width: ${rem(270)};

    @media ${media.midUp} {
      font-size: ${rem(32)};
      line-height: ${rem(40)};
      max-width: ${rem(570)};
    }
  }

  a {
    background: var(--color-white);
    border-radius: ${rem(4)};
    padding: ${rem(8)} ${rem(32)};
    margin-top: ${rem(16)};
    text-decoration: none;

    @media ${media.midUp} {
      margin-top: ${rem(40)};
    }

    h5 {
      font-size: ${rem(16)};
      line-height: ${rem(24)};
      text-decoration: none;
    }
  }
`
